import useRouter from 'Client/hooks/useRouter';
import useDeviceType from 'Client/hooks/useDeviceType';
import useSegments from 'Client/hooks/useSegments';

const useAppshellMeta = () => {
    const { isAppWebviewPage } = useRouter();
    const { getByUserAgent } = useDeviceType();
    const { webviewDevice, mobileAppWebviewVersion } = useSegments();

    const appshellMeta = {
        isApp: !!isAppWebviewPage,
        getDeviceTypeByUserAgent: getByUserAgent,
        webviewDevice,
        mobileAppWebviewVersion,
    };

    return appshellMeta;
};

export default useAppshellMeta;
